export const apiPath = '/v2/requirement_controls';
const actionType = 'REQUIREMENT_CONTROLS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
